<template>
  <div class="browse-data-container">
    <!-- 顶部导航栏 -->
    <el-row class="header-row">
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>

    <!-- 主体内容区域 -->
    <el-row class="main-content">
      <!-- 左侧菜单 -->
      <el-col :span="4" class="left-menu">
        <MenuList></MenuList>
      </el-col>

      <!-- 右侧内容区 -->
      <el-col :span="20" class="right-content">
        <!-- 顶部操作按钮 -->
        <div class="action-bar">
          <el-tooltip content="导入数据" placement="bottom">
            <el-button
              type="primary"
              @click="importData()"
              icon="el-icon-upload2"
              class="action-button">
              导入数据
            </el-button>
          </el-tooltip>
          <el-tooltip content="返回列表" placement="bottom">
            <el-button
              type="primary"
              @click="backToList()"
              icon="el-icon-back"
              class="action-button">
              返回上页
            </el-button>
          </el-tooltip>
        </div>

        <!-- 数据展示区 -->
        <div class="data-display">
          <!-- 标题区域 -->
          <div class="title-section">
            <el-divider class="custom-divider">
              <span class="form-title">{{form_name}}</span>
            </el-divider>
          </div>

          <!-- 提示信息 -->
          <div class="tip-section">
            <div class="tip-item">
              <i class="el-icon-search tip-icon"></i>
              <span class="tip-text">表示查询人需要输入的条件</span>
            </div>
          </div>

          <!-- 数据表格 -->
          <div class="table-wrapper">
            <el-table
              height="600px"
              ref="dataList"
              :data="dataList"
              class="data-table"
              border
              stripe
              :header-cell-style="headerCellStyle"
              :cell-style="cellStyle"
              empty-text="暂无数据">
              <el-table-column
                header-align="center"
                resizable
                align="center"
                :key="header"
                :label="header.label"
                :prop="header.prop"
                v-for="(header) in headers"
                :min-width="getColumnWidth(header.type)">
                <template slot="header" slot-scope="scope">
                  <div class="header-cell">
                    <div v-if="header.is_condition=='1'" class="condition-header">
                      <i class="el-icon-search condition-icon"></i>
                      <span>{{header.label}}</span>
                    </div>
                    <div v-else class="normal-header">{{header.label}}</div>
                  </div>
                </template>

                <template slot-scope="scope">
                  <!-- 图片类型 -->
                  <div v-if="header.type=='图片' || header.type=='签名'" class="image-cell">
                    <el-image
                      style="width: 80px; height: 80px;"
                      :src="scope.row[header.prop]"
                      fit="cover"
                      :preview-src-list="[scope.row[header.prop]]">
                    </el-image>
                  </div>

                  <!-- 视频类型 -->
                  <div v-else-if="header.type=='视频'" class="video-cell">
                    <video
                      :src="scope.row[header.prop]"
                      class="video-player"
                      controls>
                      您的浏览器不支持视频播放
                    </video>
                  </div>

                  <!-- 普通文本 -->
                  <div v-else class="text-cell">
                    <span class="cell-text">{{scope.row[header.prop] || '-'}}</span>
                  </div>
                </template>
              </el-table-column>

              <!-- 操作列 -->
              <el-table-column
                fixed="right"
                align="center"
                header-align="center"
                label="操作"
                width="100">
                <template slot-scope="scope">
                  <el-button
                    @click="deleteRecord(scope.row)"
                    type="text"
                    size="small"
                    class="action-btn">
                    <i class="el-icon-delete"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 分页 -->
          <div class="pagination-wrapper">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next, jumper"
              :total="total_record"
              :page-size="pageSize"
              :current-page="currentPage"
              background>
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        form_id: '',
        form_name: '',
        dataList: [],
        headers: [],

        currentPage: 1,
        pageSize: 10,
        total_record: 100,
        condition: '',

      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name
      // this.loadCourses()
      this.loadData()
    },
    methods: {
      headerCellStyle() {
        return {
          background: '#f8f9fa',
          color: '#2c3e50',
          fontWeight: '600',
          fontSize: '13px'
        }
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        return {
          fontSize: '13px',
          padding: '12px 0'
        }
      },
      getColumnWidth(type) {
        switch(type) {
          case '图片':
          case '签名':
            return 100;
          case '视频':
            return 200;
          default:
            return 120;
        }
      },
      loadData() {

        this.handleCurrentChange(1)
      },
      handleCurrentChange(currentPage) {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/wansearch/web/_load_query_data_detail.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id,
              sort_field: '',
              sort_type: '',
              current_page: currentPage,
              page_size: that.pageSize,
              condition: that.condition
            }
          }).then(function(response) {
            // that.courses_list = response.data.courses_list

            // that.tableData = response.data.student_score_list
            // that.currentItems = that.tableData
            // that.total_record = response.data.total_record

            that.dataList = response.data.dataList
            that.headers = response.data.headers
            that.total_record = response.data.total_record

            load.close()

            // that.condition = ''

            that.$forceUpdate()

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      deleteRecord(row) {
        let that = this

        var data_row_id = row.data_row_id

        this.$confirm('此操作将永久删除该行, 要删除吗?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.deleteRow(data_row_id)
        }).catch(() => {
          // that.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })

        console.log(data_row_id)
      },
      deleteRow(data_row_id) {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/wansearch/web/_delete_row_by_data_row_id.jsp'
        this.axios.get(requestUrl, {
            params: {
              data_row_id: data_row_id
            }
          }).then(function(response) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })

            load.close()

            that.loadData()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      addRow() {
        let that = this
        console.log('*******', that.form_id)
        this.$router.push({
          name: 'add_record',
          params: {
            form_id: that.form_id,
            form_name: that.form_name
          }
        })
      },
      backToList() {
        this.$router.back()
      },
      importData() {
        this.$router.push({
          name: 'import_data_excel',
          params: {
            form_id: this.form_id,
            form_name: this.form_name
          }
        })
      }
    }
  }
</script>

<style scoped>
/* ==================== 页面容器 ==================== */
.browse-data-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
}

/* ==================== 头部区域 ==================== */
.header-row {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

/* ==================== 主体内容区域 ==================== */
.main-content {
  padding: 20px;
}

.left-menu {
  padding-right: 15px;
}

.right-content {
  padding: 0 15px;
}

/* ==================== 操作按钮区域 ==================== */
.action-bar {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}

.action-button {
  font-size: 15px;
  font-weight: 500;
  padding: 12px 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-button:active {
  transform: translateY(0);
}

/* ==================== 数据展示区域 ==================== */
.data-display {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 30px;
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ==================== 标题区域 ==================== */
.title-section {
  margin-bottom: 30px;
}

.custom-divider {
  margin: 20px 0 30px 0;
}

.custom-divider >>> .el-divider__text {
  background: #ffffff;
  padding: 0 30px;
}

.form-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  letter-spacing: 1px;
}

/* ==================== 提示信息区域 ==================== */
.tip-section {
  margin-bottom: 20px;
  padding: 15px;
  background: linear-gradient(135deg, #fff7e6 0%, #ffe8cc 100%);
  border-radius: 8px;
  border-left: 4px solid #ffa940;
  animation: fadeIn 0.5s ease-out 0.2s backwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.tip-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tip-icon {
  font-size: 20px;
  color: #ffa940;
}

.tip-text {
  font-size: 14px;
  color: #d46b08;
  font-weight: 500;
}

/* ==================== 表格容器 ==================== */
.table-wrapper {
  margin-bottom: 30px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.data-table {
  border-radius: 8px;
  overflow: hidden;
}

.data-table >>> .el-table__header-wrapper {
  border-bottom: 2px solid #e9ecef;
}

/* 表格行样式 */
.data-table >>> .el-table__row {
  transition: all 0.3s ease;
}

.data-table >>> .el-table__row:hover {
  background: rgba(0, 0, 0, 0.02);
}

.data-table >>> .el-table__row:nth-child(even) {
  background: #ffffff;
}

.data-table >>> .el-table__row:nth-child(even):hover {
  background: rgba(0, 0, 0, 0.02);
}

/* ==================== 表头单元格样式 ==================== */
.header-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.condition-header {
  color: #d46b08;
  font-weight: 600;
}

.condition-icon {
  font-size: 16px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.normal-header {
  color: #2c3e50;
}

/* ==================== 表格单元格样式 ==================== */
.image-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.image-cell >>> .el-image {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.image-cell >>> .el-image:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.video-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.video-player {
  width: 200px;
  height: 150px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: cover;
}

.text-cell {
  padding: 0 10px;
  text-align: center;
}

.cell-text {
  font-size: 13px;
  color: #495057;
  line-height: 1.6;
  word-break: break-all;
}

/* ==================== 操作按钮样式 ==================== */
.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 13px;
  padding: 5px 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
  color: #495057;
}

.action-btn:hover {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  transform: translateX(2px);
}

.action-btn i {
  font-size: 14px;
}

/* ==================== 分页样式 ==================== */
.pagination-wrapper {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  animation: fadeIn 0.5s ease-out 0.4s backwards;
}

.pagination-wrapper >>> .el-pagination {
  background: #f8f9fa;
  padding: 12px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.pagination-wrapper >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #667eea;
  color: #ffffff;
}

.pagination-wrapper >>> .el-pagination.is-background .el-pager li:hover {
  color: #667eea;
}

/* ==================== 空状态样式 ==================== */
.data-table >>> .el-table__empty-block {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 60px 20px;
}

.data-table >>> .el-table__empty-text {
  color: #adb5bd;
  font-size: 14px;
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 1200px) {
  .main-content {
    padding: 15px;
  }

  .data-display {
    padding: 20px;
  }

  .form-title {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
    padding: 10px;
  }

  .left-menu {
    display: none;
  }

  .right-content {
    padding: 0;
  }

  .action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .action-button {
    width: 100%;
  }

  .data-display {
    padding: 15px;
    border-radius: 8px;
  }

  .form-title {
    font-size: 18px;
  }

  .tip-section {
    padding: 12px;
  }

  .table-wrapper {
    margin-bottom: 20px;
  }

  .video-player {
    width: 150px;
    height: 100px;
  }
}

@media (max-width: 480px) {
  .data-display {
    padding: 10px;
  }

  .form-title {
    font-size: 16px;
  }

  .tip-item {
    flex-direction: column;
    text-align: center;
  }

  .pagination-wrapper >>> .el-pagination {
    padding: 10px 16px;
  }

  .pagination-wrapper >>> .el-pagination.is-background .el-pager li {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/browse_all_data.vue